import { useState, useEffect } from "react";
import { Route, Routes, Switch } from 'react-router-dom';
import JsonData from "./data/data.json";
import Home from "./Home";
import { Header } from "./components/header";
import { Navigation } from "./components/navigation";
import { Footer } from "./components/footer";

import SmoothScroll from "smooth-scroll";
import { Privacypolicy } from "./components/privacypolicy";

function App() {

  const [landingPageData, setLandingPageData] = useState({});
  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);
  return (
    <div className="App">
      <div className="social">
        <div className="pop">
          <a className="phonescreen" href="tel:9931246965">
            <img style={{ border: "0" }} src="img/banners/callimg.png" alt="callus@9931246965" />
          </a>
        </div>
      </div>
      <Header />
      <Navigation />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/privacypolicy" element={<Privacypolicy />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
